export const isVimeoUrl = (url) =>
  Boolean(url.match(/^(https?:\/\/)?(vimeo\.com\/[0-9]+($|\?.*)|player\.vimeo\.com\/video\/[0-9]*($|\?.+))/gm))

export const isYoutubeUrl = (url) =>
  Boolean(url.match(/^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gm))

export const getVideoServiceName = (url) => {
  switch(true) {
  case isYoutubeUrl(url): return 'youtube'
  case isVimeoUrl(url): return 'vimeo'
  default: throw new Error('Unknown video service')
  }
}


// WEBPACK FOOTER //
// ./src/services/mycharity/media/video-utils.js